export const SUP_CELL_THERAPY_SELF_FIX_TOOL_LOADER = {
  desktop: `
<div class="cui-grid cui-container">
  <div class="cui-row">
    <div class="cui-col-lg-6">
      <div class="cui-skeleton-paragraph -spacing--top-40 -spacing--bottom-32">
        <div class="cui-skeleton-paragraph__content" style="width: 220px;">
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>

      <div class="cui-skeleton-heading -size--large -resolution--desktop -spacing--bottom-16">
        <div class="cui-skeleton-heading__content" style="width: 420px;">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        </div>
      </div>

      <div class="cui-skeleton-paragraph -spacing--bottom-40">
        <div class="cui-skeleton-paragraph__content" style="width: 520px;">
          <div class="cui-skeleton__item cui-skeleton__description"></div>
        </div>
      </div>

      <div class="-spacing--bottom-40" style="display: flex; align-items: center; gap: 16px;">
        <div class="cui-skeleton__item" style="width: 28px; height: 28px; border-radius: 50%;"></div>
        <div class="cui-skeleton__item" style="width: 120px; height: 2px;"></div>
        <div class="cui-skeleton__item" style="width: 28px; height: 28px; border-radius: 50%;"></div>
        <div class="cui-skeleton__item" style="width: 120px; height: 2px;"></div>
        <div class="cui-skeleton__item" style="width: 28px; height: 28px; border-radius: 50%;"></div>
      </div>

      <div class="cui-skeleton-heading -size--small -resolution--desktop -spacing--bottom-24">
        <div class="cui-skeleton-heading__content" style="width: 260px;">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        </div>
      </div>

      <div class="cui-skeleton__item -spacing--bottom-16" style="width: 100%; height: 56px;"></div>
      <div class="cui-skeleton__item -spacing--bottom-40" style="width: 100%; height: 56px;"></div>

      <div class="cui-skeleton-button -size--large -spacing--bottom-40" style="display: flex; justify-content: right;">
        <div class="cui-skeleton-button__content" style="width: 220px;">
          <div class="cui-skeleton__item cui-skeleton-button__button"></div>
        </div>
      </div>
    </div>
  </div>
</div>
`
};
